import React from 'react'

export default () => {
  return (
    <div>
        <h2>Based on your responses, this dizziness is probably due to something like  <strong>dehydration, tiredness, lack of exercise, low blood sugar, a vitamin deficiency, or stress</strong> </h2>
        <p>It is most likely temporary and not due to any serious underlying conditions.</p>
        <p>Drinking a glass of water, stretching, eating a healthy snack, or going for a walk may solve the problem.</p>
        <p>If the dizziness has been going on for a long period of time, it’s negatively impacting daily life, or is causing considerable distress, please visit a healthcare provider for more in-depth testing and diagnostics.</p>
        
    </div>
  )
}
